module.exports = __webpack_public_path__ + "static/ArchiveVideo05-83e9394ef8355bfb246e956f7bf86907.mp4";